import {
	collection,
	getDocs,
	query,
	where,
	doc,
	getDoc,
} from "firebase/firestore"
import { db } from "./firebase"

// Languages
export const getLanguages = async () => {
	const languagesCollection = collection(db, "languages")
	const languagesSnapshot = await getDocs(languagesCollection)
	return languagesSnapshot.docs.map(doc => ({
		id: doc.id,
		...doc.data(),
	}))
}

export const getLanguageByCode = async code => {
	const languagesCollection = collection(db, "languages")
	const q = query(languagesCollection, where("code", "==", code))
	const querySnapshot = await getDocs(q)

	if (querySnapshot.empty) {
		// Return default language if requested one is not found
		const defaultSnapshot = await getDocs(
			query(languagesCollection, where("code", "==", "es"))
		)
		return defaultSnapshot.docs[0].data()
	}
	return querySnapshot.docs[0].data()
}

// Courses
export const getCoursesForLanguage = async languageCode => {
	const coursesCollection = collection(db, "courses")
	const q = query(coursesCollection, where("languageCode", "==", languageCode))
	const querySnapshot = await getDocs(q)
	return querySnapshot.docs.map(doc => ({
		id: doc.id,
		...doc.data(),
	}))
}

// Flashcards
export const getFlashcardsForLanguage = async languageCode => {
	const flashcardsCollection = collection(db, "flashcards")
	const q = query(
		flashcardsCollection,
		where("languageCode", "==", languageCode)
	)
	const querySnapshot = await getDocs(q)
	return querySnapshot.docs.map(doc => ({
		id: doc.id,
		...doc.data(),
	}))
}

// Grammar Lessons
export const getSpanishGrammarLessonsByLevel = async level => {
	const lessonsCollection = collection(db, "grammarLessons")
	const q = query(
		lessonsCollection,
		where("language", "==", "es"),
		where("level", "==", level)
	)
	const querySnapshot = await getDocs(q)
	return querySnapshot.docs.map(doc => ({
		id: doc.id,
		...doc.data(),
	}))
}

export const getSpanishGrammarLessonById = async lessonId => {
	const lessonRef = doc(db, "grammarLessons", lessonId)
	const lessonSnap = await getDoc(lessonRef)

	if (lessonSnap.exists()) {
		return {
			id: lessonSnap.id,
			...lessonSnap.data(),
		}
	}
	return null
}
